/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

/**
 * Assessment models for task ratings. Note: The frontend adds a "none" option for UX purposes, which maps to `allow_task_ratings = false` on the task. This enum only contains actual assessment models that have validation rules and assessment classes.
 */
export type AssessmentModel = typeof AssessmentModel[keyof typeof AssessmentModel];


export const AssessmentModel = {
  simple: 'simple',
  grade: 'grade',
} as const;
